function getPharmacyID(): string {
    if (!localStorage.getItem('pharmacy_id')) {
        return ""
    }
    return localStorage.getItem('pharmacy_id') || ""
}

export default getPharmacyID